import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'

import { clientActions, clientSelectors, modalDialogActions } from '../../redux'
import { IdentityIntro, IdentitySms } from './components'
import { IdentityStatus } from '../../constants/enums'
import { intl, IntlInterface, wizard, WizardInterface } from '../../hoc'
import { ONLINE_VERIFICATION } from '../../constants/modals'
import { ReduxState } from '../../types'
import { SendSmsInterface } from '../../types/form'

interface Props extends IntlInterface, WizardInterface {
  identitySendSms: (payload: SendSmsInterface) => void
  identityStatus: string
  phoneNumber: string
  showModalDialog: Function
  startIdentityStatus: Function
}

interface LocalState {
  canSendSms: boolean
  smsSent: boolean
}

export class Identity extends React.Component<Props, LocalState> {
  state: LocalState = {
    canSendSms: false,
    smsSent: false,
  }

  componentDidUpdate(): void {
    if (this.state.smsSent && this.props.identityStatus === IdentityStatus.UPLOAD_FINISHED) {
      this.props.wizard.gotoNext()
    }
  }

  sendSms = () => {
    this.props.identitySendSms({
      smsSent: this.state.smsSent,
      success: () => {
        this.setState(() => ({
          canSendSms: false,
          smsSent: true,
        }))

        this.props.startIdentityStatus()
      },
      error: () => {},
    })
    setTimeout(() => {
      this.setState({ canSendSms: true })
    }, 20000)
  }

  showModal = () => this.props.showModalDialog(ONLINE_VERIFICATION)

  render() {
    const showIntro: boolean =
      this.props.identityStatus === undefined ||
      this.props.identityStatus === IdentityStatus.CANCELED

    return showIntro ? (
      <IdentityIntro
        continueMobile={this.sendSms}
        showModal={this.showModal}
        translate={this.props.translate}
      />
    ) : (
      <IdentitySms
        canSendSms={this.state.canSendSms}
        sendSms={this.sendSms}
        phoneNumber={this.props.phoneNumber}
        translate={this.props.translate}
        translateHTML={this.props.translateHTML}
      />
    )
  }
}

export const mapStateToProps = (state: ReduxState) => ({
  identityStatus: clientSelectors.selectIdentityStatus(state),
  phoneNumber: clientSelectors.selectPhoneNumber(state),
})

export const mapDispatchToProps = {
  identitySendSms: clientActions.identitySendSms,
  showModalDialog: modalDialogActions.showModalDialog,
  startIdentityStatus: clientActions.startIdentityStatus,
}

export default compose(intl, wizard, connect(mapStateToProps, mapDispatchToProps))(Identity)
